import React from 'react';

const ChevronRight = (): JSX.Element => (
  <svg viewBox="0 0 100 100">
    <polyline fill="none" points="35,25 65,50 35,75" stroke="white" strokeWidth="10" />
  </svg>
);

export default ChevronRight;
